import type { Company } from './company';

export interface Position {
  id?: number;
  companyId: number;
  title: string;
  jobUrl?: string;
  description?: string;
  requirements?: string;
  minSalary?: number;
  maxSalary?: number;
  salaryCurrency?: string;
  workType: string;
  applicationStatus: ApplicationStatus;
  interviewStatus: InterviewStatus;
  deadline?: string;
  nextInterviewDate?: string;
  priority: number;
  createdAt?: string;
  updatedAt?: string;
  company?: {
    id: number;
    name: string;
    logo?: string;
  };
}

export type ApplicationStatus = 
  | 'not_started'
  | 'resume_sent'
  | 'resume_viewed'
  | 'screening'
  | 'interview'
  | 'offer_received'
  | 'offer_accepted'
  | 'offer_declined'
  | 'rejected'
  | 'withdrawn';

export type InterviewStatus = 
  | 'not_scheduled'
  | 'scheduled'
  | 'completed'
  | 'skipped'
  | 'cancelled';

export interface PositionQueryParams {
  page?: number;
  size?: number;
  companyId?: number;
  workType?: string;
  applicationStatus?: ApplicationStatus;
  interviewStatus?: InterviewStatus;
  minSalary?: number;
  maxSalary?: number;
  priority?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

export interface PositionSearchParams {
  keyword: string;
  page?: number;
  size?: number;
}

export const APPLICATION_STATUS_MAP: Record<ApplicationStatus, string> = {
  'not_started': '未开始',
  'resume_sent': '简历已投递',
  'resume_viewed': '简历已查看',
  'screening': '筛选中',
  'interview': '面试中',
  'offer_received': '收到Offer',
  'offer_accepted': 'Offer已接受',
  'offer_declined': 'Offer已拒绝',
  'rejected': '已被拒绝',
  'withdrawn': '已撤回'
};

export const INTERVIEW_STATUS_MAP: Record<InterviewStatus, string> = {
  'not_scheduled': '未安排',
  'scheduled': '已安排',
  'completed': '已完成',
  'skipped': '已跳过',
  'cancelled': '已取消'
};

export const WORK_TYPE_OPTIONS = [
  { label: '全职', value: 'full_time' },
  { label: '兼职', value: 'part_time' },
  { label: '实习', value: 'internship' },
  { label: '合同工', value: 'contract' },
  { label: '自由职业', value: 'freelance' },
  { label: '远程工作', value: 'remote' }
];

export const PRIORITY_OPTIONS = [
  { label: '非常高', value: 5 },
  { label: '高', value: 4 },
  { label: '中', value: 3 },
  { label: '低', value: 2 },
  { label: '非常低', value: 1 }
];

export const CURRENCY_OPTIONS = [
  { label: '人民币 (CNY)', value: 'CNY' },
  { label: '美元 (USD)', value: 'USD' },
  { label: '欧元 (EUR)', value: 'EUR' },
  { label: '英镑 (GBP)', value: 'GBP' },
  { label: '日元 (JPY)', value: 'JPY' },
  { label: '韩元 (KRW)', value: 'KRW' },
  { label: '港币 (HKD)', value: 'HKD' },
  { label: '新加坡元 (SGD)', value: 'SGD' }
]; 